module.exports = __webpack_public_path__ + "static/media/tumblr.df2add19.svg";